import type { getOneOrderOutput } from "@/api/custom_types";
import { useTranslation } from "@/hooks";
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Icon,
	Typography,
} from "@st-marketplace/ui";
import { OrderDetailsInfoBalanceScreenshot } from "./components";

interface OrderDetailsInfoBalanceProps {
	order: getOneOrderOutput;
}

function OrderDetailsInfoBalance({ order }: OrderDetailsInfoBalanceProps) {
	const { t } = useTranslation();

	// a customer-link order not claimed yet has no account, so no balance either
	if (order.schema_type === "end_customer_unclaimed") return null;
	if (!order.starting_balance_sc && !order.ending_balance_sc) return null;

	return (
		<div className="col-span-1 md:col-span-2">
			<Card className="border-secondary-border">
				<CardHeader>
					<div className="flex items-center gap-3">
						<Icon name="image-line" className="text-primary-100" />
						<CardTitle>
							<Typography variant="title-sm">
								{t("orderInfo.info.cardScreenshotTitle").toUpperCase()}
							</Typography>
						</CardTitle>
					</div>
				</CardHeader>
				<CardContent className="flex flex-col justify-between gap-8 md:flex-row">
					{order.starting_balance_sc ? (
						<div className="w-full md:w-1/2">
							<OrderDetailsInfoBalanceScreenshot
								src={`data:image/png;base64,${order.starting_balance_sc}`}
								title={t("orderInfo.info.cardScreenshotStartingBalance")}
							/>
						</div>
					) : null}
					{order.ending_balance_sc ? (
						<div className="w-full md:w-1/2">
							<OrderDetailsInfoBalanceScreenshot
								src={`data:image/png;base64,${order.ending_balance_sc}`}
								title={t("orderInfo.info.cardScreenshotEndingBalance")}
							/>
						</div>
					) : null}
				</CardContent>
			</Card>
		</div>
	);
}

export default OrderDetailsInfoBalance;
